var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPortofolioBannerMobile(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 622.974,
    height: 340.787,
    viewBox: "0 0 622.974 340.787",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Intersection_5",
    "data-name": "Intersection 5",
    d: "M27.229,330.16C35.715,250.383,329.636,138.5,432.081,121.3S592.068,119.057,626,170.636s37.347,132.99-28.082,162.74-66.082,5.606-155.262,36.045S336.313,452.1,241.2,455.134c-2.827.09-5.689.135-8.569.135C138.628,455.271,19,407.564,27.229,330.16Z",
    transform: "translate(-26.827 -114.481)",
    fill: "#eda751"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortofolioBannerMobile);
export default __webpack_public_path__ + "static/media/portofolioBannerMobile.bb5222fd2645b5c5f651b0a1fd306345.svg";
export { ForwardRef as ReactComponent };